/* eslint-disable array-callback-return */
/* eslint-disable no-useless-escape */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react/no-children-prop */
import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useCallback,
  useState,
  ElementType,
  useEffect
} from 'react'
import {
  FormControl,
  FormLabel,
  Input as ChakraInput,
  InputProps as ChakraInputProps,
  FormErrorMessage,
  InputGroup,
  InputRightElement,
  Icon,
  Stack,
  Box,
  Text,
  Flex
} from '@chakra-ui/react'
import { FieldError } from 'react-hook-form'

import { mask } from '../../utils/mask'
import { useAuth } from '../../hooks/auth'

interface InputProps extends ChakraInputProps {
  name: string
  label?: string
  error?: FieldError
  type?: string
  isRequired?: boolean
  iconRight?: ElementType
  _active?: any
  disabled?: boolean
  size?: string
  defaultValue?: any
}

interface InputMaskObserver {
  cep: string
}

const InputDate: ForwardRefRenderFunction<HTMLInputElement, InputProps> = (
  {
    name,
    label,
    error = null,
    type = 'number',
    isRequired = false,
    iconRight,
    disabled,
    value,
    size = 'md',
    defaultValue,
    ...rest
  },
  ref
) => {
  // aplicar mascaras Date MM/AAAA
  const handleKeyUpEvent = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      e.currentTarget.maxLength = 7
      let inputValue = e.currentTarget.value
      inputValue = inputValue.replace(/\D/g, '')
      inputValue = inputValue.replace(/^(\d{2})(\d)/, '$1/$2')
      e.currentTarget.value = inputValue
    },
    []
  )

  return (
    <Stack direction="row" w="100%" spacing="4" placeholder="">
      <Box w="75%" flex="1">
        <FormControl
          isInvalid={!!error}
          isRequired={isRequired}
          bgColor="white"
        >
          {!!label && (
            <FormLabel fontSize="14px" htmlFor={name}>
              {label}
            </FormLabel>
          )}
          <InputGroup display="flex" alignItems="center">
            <Flex w="100%" align="center">
              <ChakraInput
                w="100%"
                borderRadius="none"
                name={name}
                id={name}
                focusBorderColor="blue.400"
                bgColor="white"
                borderColor="gray.100"
                borderWidth="1px"
                variant="filled"
                disabled={disabled}
                _hover={{
                  bgColor: 'blue.50'
                }}
                value={value}
                size={size}
                ref={ref}
                onKeyUp={handleKeyUpEvent}
                {...rest}
              />
              {!!iconRight && (
                <InputRightElement
                  mt={size === 'md' ? '0px' : '4px'}
                  children={
                    <Icon
                      as={iconRight}
                      fontSize={size === 'md' ? '20px' : '24px'}
                      color="#9699B0"
                    />
                  }
                />
              )}
            </Flex>
          </InputGroup>
          {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
        </FormControl>
      </Box>
    </Stack>
  )
}

export const InputTypeDate = forwardRef(InputDate)
